/* global require */

// This JS file is loaded on pages that have not been converted to Turbo. It's
// designed to bridge the gap between the old jQuery JavaScript and the newer
// Turbo implementation.
//
// From here, we can replace global jQuery functions with Stimulus controllers
// and use `turbo_frame` and similar features from Hotwire.

import { Application } from "stimulus";
import { Turbo } from "@hotwired/turbo-rails";
import { definitionsFromContext } from "stimulus/webpack-helpers";

// The main difference between existing jQuery pages and Turbo is that the
// latter supports turbo-drive. The former does not, so we need to disable it.
Turbo.session.drive = false;

const application = Application.start();
const context = require.context("../controllers", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
